export default () => {
  return 'mdi-heart'
}
